import type { ClockResources } from './en-US.js';

export const zhHans: ClockResources = {
  nav: {
    clock: '打卡',
    records: '考勤记录',
    requests: '更正申请',
    approvals: '审批',
    team: '团队',
    schedules: '排班',
  },
  clock: {
    now: '当前时间（{{timeZone}}）',
    status: '状态',
    since: '自 {{time}}',
    today: '今日打卡',
    noPunches: '今天还没有打卡。',
    recorded: '已于 {{time}} 记录。',
    needsCorrection:
      '{{dates}} 开始的工作已在上班 24 小时后自动下班。请提交更正申请，填写实际的下班时间。',
    requestCorrection: '申请更正',
    endAgainHint: '再次点击“下班”可更新下班时间。',
    location: {
      title: '位置',
      granted: '已允许使用位置信息。',
      prompt: '打卡时浏览器会请求使用您的位置。',
      denied: '位置信息已被阻止。请在浏览器设置中允许后再打卡。',
      unsupported: '此浏览器无法获取位置。',
      locating: '正在获取位置…',
    },
    error: {
      title: '需要位置信息',
      denied: '此网站的位置权限已被阻止。请在浏览器的网站设置中允许位置访问，然后重试。',
      unavailable: '无法获取您的位置。请确认设备已开启定位服务，然后重试。',
      timeout: '获取位置超时。请移动到信号较好的地方，然后重试。',
      unsupported: '此浏览器无法获取位置。请使用其他浏览器或设备打卡。',
    },
  },
  records: {
    title: '考勤记录',
    titleOf: '{{name}} 的考勤记录',
    previousMonth: '上个月',
    nextMonth: '下个月',
    date: '日期',
    schedule: '排班',
    actual: '工作时段',
    breaks: '休息',
    worked: '工作时长',
    late: '迟到',
    earlyLeave: '早退',
    overtime: '加班',
    holidayWork: '休息日工作',
    notes: '备注',
    dayOff: '休息日',
    missingPunch: '漏打卡',
    modified: '已更正',
    pending: '申请中',
    outsideGeofence: '范围外打卡',
    endUpdated: '下班时间已更新',
    autoEnded: '自动下班',
    totals: '本月合计',
    calendar: '日历',
    daysWorked: '出勤天数',
    lateCount: '迟到次数',
    earlyLeaveCount: '早退次数',
    missingPunches: '漏打卡',
    exportMonth: '月度（CSV）',
    exportYear: '年度（CSV）',
  },
  day: {
    back: '返回考勤记录',
    schedule: '排班',
    noSchedule: '无排班',
    noRecord: '当天没有记录。',
    breaks: '休息',
    noBreaks: '无休息',
    punches: '打卡',
    showOnMap: '地图',
    evidence: '打卡详情（主管和管理员可见）',
    ip: 'IP 地址',
    accuracy: '精度',
    geofence: '地理围栏',
    nearestArea: '最近的区域',
    distance: '距离',
    meters: '{{value}} 米',
    requests: '更正申请',
    requestChange: '申请更正',
  },
  request: {
    title: '更正申请',
    hint: '请输入应记录的时间，包括所有休息。主管审批后生效。',
    workDate: '工作日期',
    start: '开始',
    end: '结束',
    breaks: '休息',
    addBreak: '添加休息',
    removeBreak: '删除休息',
    breakStart: '休息开始',
    breakEnd: '休息结束',
    reason: '原因',
    submit: '提交申请',
  },
  requests: {
    title: '更正申请',
    empty: '还没有申请。',
    newRequest: '新建申请',
    withdraw: '撤回',
    requestedAt: '申请时间 {{time}}',
    reviewedBy: '{{name}}，{{time}}',
    comment: '备注',
    requested: '申请内容',
    current: '当前记录',
  },
  approvals: {
    title: '审批',
    empty: '没有待审批的申请。',
    comment: '备注（可选）',
  },
  team: {
    title: '团队',
    today: '今天',
    month: '本月',
    group: '组',
    allGroups: '所有组',
    member: '成员',
    state: '状态',
    since: '开始',
    warnings: '提醒',
    outsideGeofence: '在范围外打卡',
    needsCorrection: '有需要更正的工作记录',
    pendingRequests: '{{count}} 个申请',
    worked: '工作时长',
    daysWorked: '天数',
    overtime: '加班',
    late: '迟到',
    missingPunches: '漏打卡',
    outsideDays: '范围外',
    empty: '没有成员。',
  },
  schedules: {
    title: '排班',
    group: '组',
    groupDefault: '组的默认排班',
    individual: '个人排班',
    member: '成员',
    effectiveFrom: '生效日期',
    weekday: '星期',
    workday: '工作日',
    start: '开始',
    end: '结束',
    breakMinutes: '休息（分钟）',
    overnightHint: '结束时间早于或等于开始时间表示次日结束。',
    versions: '版本',
    inEffect: '生效中',
    empty: '还没有排班。',
    saved: '排班已保存。',
    useGroupDefault: '没有个人排班，适用组的默认排班。',
  },
  geofences: {
    title: '地理围栏',
    description: '不在组内任何有效区域的打卡会被接受，但会向主管和管理员标记。',
    name: '名称',
    latitude: '纬度',
    longitude: '经度',
    radius: '半径（米）',
    active: '启用',
    add: '添加区域',
    mapHint: '点击地图可移动中心点。',
    empty: '此组没有区域。',
  },
  audit: {
    title: '审计日志',
    time: '时间',
    actor: '操作人',
    action: '操作',
    target: '对象',
    system: '系统',
    actions: {
      ScheduleChanged: '排班变更',
      GeofenceChanged: '地理围栏变更',
      ModificationRequested: '提交更正申请',
      ModificationApproved: '批准更正申请',
      ModificationRejected: '驳回更正申请',
      ModificationCancelled: '撤回更正申请',
      CsvExported: '导出 CSV',
      LocalAdminGranted: '添加管理员',
      LocalAdminRevoked: '移除管理员',
    },
  },
};
